import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/linguists',
    name: 'linguists',
    meta: {
      title: 'Linguists'
    },
    component: () => import('@/views/linguists/Linguists.vue')
  },
  {
    path: '/linguists/create',
    name: 'linguist-create',
    meta: {
      title: 'Create Linguist'
    },
    component: () => import('@/views/linguists/LinguistCreateView.vue')
  },
  {
    path: '/linguists/:id',
    name: 'linguist-edit',
    props: true,
    meta: {
      title: 'Edit Linguist'
    },
    component: () => import('@/views/linguists/LinguistEditView.vue')
  },
  {
    path: '/linguist-groups',
    name: 'linguist-groups',
    meta: {
      title: 'Linguist Groups'
    },
    component: () => import('@/views/linguists/LinguistGroupsView.vue')
  },
  {
    path: '/linguist-groups/create',
    name: 'linguist-groups-create',
    meta: {
      title: 'Create Linguist Groups'
    },
    component: () => import('@/views/linguists/LinguistGroupsCreateView.vue')
  },
  {
    path: '/linguist-groups/:id',
    name: 'linguist-groups-edit',
    props: true,
    meta: {
      title: 'Edit Linguist Groups'
    },
    redirect: ({ params }) => {
      return {
        name: 'linguist-groups-edit-section',
        params: {
          ...params,
          section: 'info'
        }
      }
    },
    component: () => import('@/views/linguists/LinguistGroupsEditView.vue'),
    children: [
      {
        path: '/linguist-groups/:id/f/:section/:action/:actionId',
        name: 'linguist-groups-edit-section-action',
        props: true,
        meta: {
          title: 'Edit Linguist Group'
        },
        component: () => import('@/views/linguists/LinguistGroupsEditView.vue')
      },
      {
        path: '/linguist-groups/:id/f/:section',
        name: 'linguist-groups-edit-section',
        props: true,
        meta: {
          title: 'Edit Linguist Group'
        },
        component: () => import('@/views/linguists/LinguistGroupsEditView.vue')
      }
    ]
  }
]

export default routes
